export function sleep(ms) {
    return new Promise((resolve) => {
        setTimeout(() => resolve(null), ms);
    });
}
//# sourceMappingURL=sleep.js.map